// Auto-refactored from translations.js on 2026-08-19
// Locale: sr

const sr = {
  wieMoeglich: { question: 'Kako je to moguće?', answer: 'Iznova smo osmislili lanac vrednosti.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'STIG ROCK put',
    fazit: 'Skraćeni lanac snabdevanja eliminiše najveće troškovne stavke.',
    fazitBigPre: 'To omogućava popust do',
    fazitBigValue: '80%',
    steps: [ 'Rudnik', 'Brusionica', 'Sertifikacija', 'Krajnji kupac' ]
  },
  nav: { language: 'Jezik', contact: 'Kontakt' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Jedinstvena prilika',
    subtitle: 'Izgradite bogatstvo orijentisano na budućnost.',
    description: 'STIG ROCK je međunarodna platforma koja ljudima pruža pristup prirodnim dijamantima, održivom izgradnjom bogatstva i jedinstvenom zajednicom.',
    scroll: 'Skrolujte da istražite'
  },
  disclaimer: {
    overline: 'Pravna napomena',
    title: 'Disclaimer',
    paragraphs: [
      'Ova prezentacija služi isključivo u informativne svrhe i ne predstavlja finansijsko, investiciono ili poresko savetovanje.',
      'STIG ROCK nije finansijski proizvod, već se odnosi na prirodne dijamante kao materijalna sredstva.',
      'Ne garantuje se kretanje vrednosti, dobit ili prihod. Prošla kretanja nisu indikacija budućih rezultata.',
      'Svi prikazani proračuni u vezi sa provizijama su isključivo primeri i takođe ne predstavljaju garanciju.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'IZGRAĐENO', 'NA STRUKTURI' ],
    body: 'STIG Group je internacionalni konzorcijum, izgrađen na jasnoći, odgovornosti i dugoročnoj vrednosti. Svaki brend, svaki poduhvat i svako partnerstvo prate jedan standard — bez prečica, bez izuzetaka.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'IZGRAĐENO', 'NA STRUKTURI' ],
        body: 'STIG Group je internacionalni konzorcijum, izgrađen na jasnoći, odgovornosti i dugoročnoj vrednosti. Svaki brend, svaki poduhvat i svako partnerstvo prate jedan standard — bez prečica, bez izuzetaka.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'SVET', 'EKSKLUZIVNIH DIJAMANATA' ],
        body: 'STIG ROCK je moderan koncept STIG Group koji povezuje visokokvalitetne GIA-sertifikovane dijamante sa transparentnim strukturama i ekskluzivnim korisničkim iskustvom. Jasni planovi rešenja, profesionalna realizacija i internacionalna orijentacija.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'INTERNACIONALNA', 'TRGOVINA DIJAMANTIMA' ],
        body: 'STIG International je deo STIG Group i specijalizovan je za međunarodnu trgovinu GIA-sertifikovanim dijamantima. Fokus na kvalitetu, poverenju i modernim trgovačkim strukturama sa globalnim partnerstvima.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'ODGOVORNOST', 'OD SAMOG RUDNIKA' ],
        body: 'Ethical Mines se zalaže za odgovornu eksploataciju, sledljivo poreklo i dijamante bez konflikata. Od rudnika do tržišta — potpuna dokumentacija za transparentnost, integritet i dugoročnu odgovornost duž celog lanca snabdevanja.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Dijamanti',
    stigDrawback: 'Realno skladište vrednosti',
    overline: 'Mogućnosti',
    title: 'Mogućnosti za izgradnju bogatstva',
    subtitle: 'Poređenje sa konvencionalnim načinima.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex ili Kripto',
        drawback: 'visoko spekulativno, nepredvidivo, kompleksno'
      },
      {
        tag: 'Akcije',
        name: 'Berzanska trgovina',
        drawback: 'rizik od fluktuacija, potrebno znanje, utrošak vremena'
      },
      {
        tag: 'Kripto',
        name: 'Trgovina',
        drawback: 'volatilnost, regulatorni rizik, sigurnosni propusti'
      }
    ]
  },
  chance: {
    overline: 'Dijamanti',
    title: 'Potcenjena prilika',
    body: 'Dijamanti godinama spadaju u oblike ulaganja sa najstabilnijom vrednošću i najvećim šansama, ali je do sada samo mali broj ljudi koristio ovaj potencijal.',
    callout: 'Sa našim STIG ROCK po prvi put otvaramo pristup ovim izuzetnim mogućnostima za sve.'
  },
  wertentwicklung: {
    overline: 'Razvoj vrednosti 1995 — 2025',
    title: 'Priča o vrednosti.',
    usd: 'Američki dolar',
    usdValue: '-49%',
    diamond: 'Dijamanti',
    diamondValue: '+185%',
    note: 'Razvoj od 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Glavni razlozi',
    title: 'Šest razloga za dijamante',
    lead: 'Dijamanti su realna materijalna sredstva koja postoje nezavisno od valuta i finansijskih sistema — i vekovima čuvaju svoju vrednost.',
    items: [
      {
        n: '01',
        title: 'Stabilnost vrednosti otporna na krize',
        body: 'Garancija materijalne vrednosti. Nezavisno od valuta i finansijskih sistema.'
      },
      {
        n: '02',
        title: 'Ultimativna mobilnost',
        body: 'Mali, laki za skrivanje i transport.'
      },
      {
        n: '03',
        title: 'Diversifikacija i oskudica',
        body: 'Uskla grla u snabdevanju i prirodna ograničenost.'
      },
      { n: '04', title: 'Dugoročni rast', body: '+185% od 1995.' },
      {
        n: '05',
        title: 'Transparentnost i ekskluzivnost',
        body: '4 C kao garancija: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Rezerva kraljevskih porodica',
        body: 'Čak i kraljevske porodice koriste dijamante kao rezervu bogatstva.'
      }
    ]
  },
  markt: {
    overline: 'Obim tržišta',
    title: '99 — 108 Mrd. USD',
    sub: 'Obim trgovine u 2025. godini',
    forecast: 'Prognoza do ~2032 / 2034: oko 140 – 168 Mrd. USD uz umeren rast (~4 – 5 % p.a.).',
    source: 'Izvor: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Inovacija',
    title: 'Inovacija. Prvi put u svetu.',
    body: 'STIG ROCK je prva platforma na svetu koja omogućava ljudima da ostvare pasivan prihod na tržištu dijamanata uz povećanje vrednosti.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Registarski br. DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'O kompaniji',
    titleLines: [ 'INTERNACIONALNA', 'STRUKTURA', 'JASNA VIZIJA' ],
    body: 'STIG ROCK je osnovan kako bi tržište dijamanata učinio transparentnijim, modernijim i orijentisanim ka kupcima — sa fokusom na poverenje, sigurnost i dugoročnu strukturu.'
  },
  sicherheit: {
    overline: 'Kvalitet i sigurnost',
    title: 'Gemological Institute of America',
    body: 'Sertifikovana ekspertiza za Vaše dijamante. GIA ocenjuje svaki kamen sa najvišom preciznošću i dugogodišnjim iskustvom — pouzdane procene vrednosti za našu kompaniju i naše kupce.',
    transparency: 'Svaki dijamant ispunjava najviše standarde kvaliteta i proveren je i sertifikovan od strane renomiranih organizacija. Svaki kamen je jedinstven i dobija individualni sertifikat.',
    kimberley: 'Kimberley Process — radimo isključivo sa dijamantima bez konflikata.'
  },
  plaene: {
    overline: 'Solution planovi (SP)',
    title: 'Jedinstvena inovacija proizvoda',
    sub: 'Šest stepenovanih Solution planova — od $1K do $100K+, svaki sa rastućim popustom mesečno i tokom celog trajanja.',
    recommended: 'Popularno',
    oneYear: '1 godina',
    rowLabels: {
      delivery: 'Vreme isporuke',
      price: 'Cena proizvoda',
      carat: 'Karat',
      monthly: 'Popust (mesečno)',
      totalDiscount: 'Popust (ukupno)',
      duration: 'Trajanje'
    },
    headers: {
      plan: 'Plan',
      from: 'Od',
      carat: 'Karat',
      monthly: 'Popust / mesec',
      total: 'Popust ukupno',
      duration: 'Trajanje'
    },
    duration: '1 godina',
    footnote: 'Sve cene su bez garancije i zavise od kvaliteta, potražnje i trenutnog razvoja tržišta. Solution planovi su mogući i na 2 godine.'
  },
  plaeneVIP: {
    overline: 'Solution planovi + VIP paket',
    title: 'Uz VIP paket još veći popust',
    sub: 'Ukupan popust po planu – u kombinaciji sa VIP paketom dobijate dodatnih +1% do +3%, što osetno povećava ukupan popust.',
    rowLabels: {
      delivery: 'Vreme isporuke',
      price: 'Cena proizvoda',
      carat: 'Karat',
      monthly: 'Popust (mesečno)',
      totalDiscount: 'Popust (ukupno)',
      vip1: 'VIP paket 1 (+1%)',
      vip2: 'VIP paket 2 (+2%)',
      vip3: 'VIP paket 3 (+3%)'
    },
    footnote: 'Sve cene su bez garancije i zavise od kvaliteta, potražnje i trenutnog razvoja tržišta.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Vaše mogućnosti',
    sub: 'Nakon isteka Vašeg Solution plana, možete ili prodati svoje dijamante nazad nama, ili tražiti da Vam budu isporučeni na kućnu adresu.',
    options: [
      {
        key: 'deliver',
        title: 'Isporuka',
        body: 'Dijamanti (Karat) po ceni Vašeg DS plana*'
      },
      {
        key: 'sellToUs',
        title: 'Prodaja nama',
        body: 'Možete prodati svoje dijamante nazad nama po kupovnoj ceni koju ste platili.'
      },
      {
        key: 'sellThirdParty',
        title: 'Prodaja trećim licima',
        body: 'Možete preprodati svoje dijamante trećim licima.'
      }
    ],
    footnote: '*DS plan označava Solution plan.'
  },
  tradWeg: {
    overline: 'Tradicionalna trgovina',
    title: 'Tradicionalni put',
    sub: 'Pre nego što dijamant stigne do krajnjeg kupca, kroz posredničku, veleprodajnu i maloprodajnu trgovinu nastaju značajne trgovačke marže u odnosu na cenu sirovog dijamanta iz rudnika.',
    steps: [
      { title: 'Rudnik', subtitle: 'Sirovi dijamanti' },
      { title: 'Posrednik', subtitle: 'Kupovina sirovih dijamanata' },
      { title: 'Brusionica', subtitle: 'Brušenje u nakitne dijamante' },
      { title: 'Sertifikacija', subtitle: 'od strane priznatih instituta kao što je GIA' },
      { title: 'Berza dijamanata', subtitle: 'Prodaja veleprodaji' },
      { title: 'Veleprodaja', subtitle: 'Prodaja maloprodaji' },
      { title: 'Maloprodaja', subtitle: 'npr. zlatare' },
      { title: 'Krajnji kupci', subtitle: 'Kupovina dijamanata' }
    ]
  },
  stigWeg: {
    overline: 'STIG ROCK',
    title: 'STIG ROCK put',
    sub: 'Mi prekidamo ovaj ciklus tako što kupujemo sirove dijamante direktno iz rudnika, dajemo ih na brušenje i sertifikaciju preko naših partnera. Na taj način možemo te trgovačke marže proslediti našim kupcima u obliku popusta.',
    duration: '12 meseci – trajanje DS plana',
    centerBig: '04',
    centerCaption: 'Do 4 trgovačka ciklusa tokom trajanja DS plana',
    cycle: [
      { n: '1.', title: 'Kupovina više sirovih dijamanata', body: 'za jedan DS plan' },
      { n: '2.', title: 'Brušenje i sertifikacija', body: 'preko naših partnera' },
      { n: '3.', title: 'Prodaja krajnjim kupcima', body: 'i veletrgovcima' },
      { n: '4.', title: 'Ovaj postupak ponavljamo', body: 'do 4× godišnje' }
    ],
    steps: [
      { title: 'Rudnik', subtitle: 'Sirovi dijamanti' },
      { title: 'Brusionica', subtitle: 'preko naših partnera' },
      { title: 'Sertifikacija', subtitle: 'od strane priznatih instituta' },
      { title: 'Krajnji kupci', subtitle: 'Kupovina i popusti' }
    ],
    footnote: '*DS plan označava Solution plan.'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP paketi',
    sub: 'Važe 12 meseci za sve Vaše aktivirane Solution planove. Zavisno od VIP paketa: +1% do +3% dodatnog popusta',
    cardKicker: 'dodatno – na sve',
    cardKicker2: 'Solution planove',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Popusti postaju uštede',
      body: 'Mesečna ušteda umesto mesečnog opterećenja. Iz popusta nastaju uštede – a one plaćaju upravo one stvari koje inače svakog meseca plaćate iz sopstvenog džepa.',
      line1Label: 'DS plan od',
      line1Value: '$5.000',
      line2Label: 'mes. popust',
      line2Value: '3%',
      line3Label: 'VIP paket 3',
      line3Value: '+3%',
      resultLabel: 'mes. uštede',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Kako je to moguće?',
    title: 'Ponovo smo osmislili lanac vrednosti.',
    traditionalTitle: 'Tradicionalni put',
    traditionalSteps: [
      'Rudnik — Sirovi dijamanti',
      'Posrednik — Kupovina',
      'Brusionica — Brušenje',
      'Sertifikacija (GIA)',
      'Berza dijamanata — Veleprodaja',
      'Veleprodaja → Maloprodaja',
      'Zlatare → Krajnji kupac'
    ],
    traditionalNote: 'Pre nego što dijamant stigne do krajnjeg kupca, kroz posredničku, veleprodajnu i maloprodajnu trgovinu nastaju značajne trgovačke marže.',
    stigTitle: 'STIG ROCK put',
    stigSteps: [
      'Direktna kupovina — Sirovi dijamanti iz rudnika',
      'Brušenje i sertifikacija preko naših partnera',
      'Prodaja krajnjim kupcima i B2B klijentima',
      'Do 4 trgovačka ciklusa godišnje'
    ],
    stigNote: 'Prekidamo ciklus i prosleđujemo trgovačke marže kao popuste našim kupcima — do 4 trgovačka ciklusa tokom trajanja DS plana.'
  },
  optionen: {
    overline: 'Vaše mogućnosti',
    title: 'Nakon isteka Vašeg Solution plana',
    items: [
      { title: 'Isporuka', body: 'Dijamanti (Karat) po ceni Vašeg DS plana.' },
      {
        title: 'Prodaja nama',
        body: 'Povratna prodaja po kupovnoj ceni koju ste platili.'
      },
      { title: 'Prodaja trećim licima', body: 'Prodaja dijamanata na slobodnom tržištu.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution planovi — jedinstvena inovacija proizvoda',
    title: 'Jednostavan put',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Registracija',
        body: 'Kontaktirajte osobu koja Vam je preporučila i kreirajte besplatan nalog!'
      },
      { n: '02', icon: 'cart', title: 'Kupovina proizvoda', body: 'Već od $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Ostvarivanje popusta',
        body: 'Primajte mesečne popuste.'
      }
    ]
  },
  business: {
    overline: 'Vrste bonusa',
    title: 'Najjednostavniji i najpošteniji put.',
    sub: 'Pet vrsta bonusa — za Vašu uspešnu izgradnju poslovanja.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Do nivoa 3, od nivoa karijere Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Od Sapphire — neograničeno duboko.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Na Infinity Bonus – do nivoa 5 · BEZ kvalifikacije.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 Pool-a od svetskog prometa.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Jednokratni bonus u dijamantima (Karat).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Ovaj bonus Vam se isplaćuje za svaki novi Solution plan do 3. nivoa. Sa veoma malim kvalifikacijama otključavate pojedinačne nivoe.',
    total: 'Do 18% Unilevel Bonus',
    levels: [
      {
        level: 'Nivo 1',
        value: '10%',
        qual: 'od samog početka',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Nivo 2',
        value: '5%',
        qual: 'od nivoa karijere Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Nivo 3',
        value: '3%',
        qual: 'od nivoa karijere Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Od nivoa karijere Sapphire kvalifikovani ste za naš Infinity Bonus plan. Dobijate 3% bonusa. Sa svakim novim nivoom karijere dodaju se novi procenti. Ako je Partner u Vašem timu takođe kvalifikovan, dobijate razliku između rangova.',
    exampleTitle: 'Primer',
    exampleRows: [
      { label: 'Vi ste Blue Diamond', value: '12%' },
      { label: 'Vaš Partner je Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Vaš Infinity Bonus', value: '9%' },
    totalNote: 'Ukupno do 24% Infinity Bonus na sve Solution planove u Vašem timu — neograničeno duboko.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Sa ovim bonusom profitirate od uspeha Vašeg tima. Dobijate Matching Bonus od 5% na Infinity Bonus Vaših partnera — i to do 5. nivoa Vašeg tima.',
    note: 'Na sve isplate Infinity Bonus-a u Vašem timu – do 5. nivoa. Od samog početka – BEZ kvalifikacije.',
    levels: [
      { level: 'Nivo 1', value: '5%' },
      { level: 'Nivo 2', value: '5%' },
      { level: 'Nivo 3', value: '5%' },
      { level: 'Nivo 4', value: '5%' },
      { level: 'Nivo 5', value: '5%' }
    ],
    totalPrefix: 'Ukupno do',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% svetskog prometa ide u jednakim delovima u 3 različita Pool-a. Postizanjem određenih nivoa karijere kvalifikujete se za svaki pojedinačni Pool.',
    forever: 'Jednom dostignuto – ZAUVEK učestvujete!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'od Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'od Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'od Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Ukupno',
    totalValue: '3%',
    totalSuffix: 'svetskog prometa'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Od nivoa karijere Diamond dobijate Rang Bonus. On se isplaćuje u dijamantima (Karat). Ovde se radi o jednokratnom bonusu.',
    highlight: 'Dijamanti (Karat) u ukupnoj vrednosti od',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Nivoi karijere',
    title: 'Nivoi karijere',
    sub: 'Za dostizanje odgovarajućih nivoa karijere računa se istorijski ukupni promet (HG). On mora biti raspoređen na više timova počevši od nivoa Sapphire. Da biste dostigli Ruby ili viši nivo, potrebna su Vam najmanje dva direktna Partner-a sa Solution planom.',
    forever: 'Jednom dostignuto – ZAUVEK potvrđeno!',
    footnote: 'HV = Istorijski ukupni promet.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 dir. Pearl', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Krenite sa nama',
    title: 'Pravo vreme je upravo sada.',
    body: 'Ovaj poslovni model postavlja nove standarde i objedinjuje sve faktore uspeha za dugoročno održivo i uspešno poslovanje. Registrujte se još danas, odaberite svoj Solution plan i iskoristite ovu jedinstvenu poslovnu priliku.',
    hint: 'Razgovarajte sa osobom koja Vas je pozvala na ovu prezentaciju — ona ima link za registraciju za Vas.',
    formName: 'Ime',
    formEmail: 'E-mail',
    formPhone: 'Telefon',
    formSubmit: 'Stupite u kontakt',
    success: 'Hvala Vam — javićemo Vam se diskretno i lično.',
    callCta: 'Pozovite',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Pravna napomena i Disclaimer',
    disclaimer: 'Ova prezentacija služi isključivo u informativne svrhe i ne predstavlja finansijsko, investiciono ili poresko savetovanje. STIG ROCK nije finansijski proizvod, već se odnosi na prirodne dijamante kao materijalna sredstva. Ne garantuje se kretanje vrednosti, dobit ili prihod. Prošla kretanja nisu indikacija budućih rezultata. Svi prikazani proračuni u vezi sa provizijama su isključivo primeri i takođe ne predstavljaju garanciju. Zadržavamo pravo na izmene sadržaja — slobodan prevod (nije zvaničan prevod).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. Sva prava zadržana.',
    version: 'Verzija: DS-12-2025 V3'
  },
  misc: { next: 'Sledeća sekcija' }
};

export default sr;
